/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import DescriptionIcon from "@material-ui/icons/Description";
import LanguageIcon from "@material-ui/icons/Language";
import { shallowEqual, useSelector } from "react-redux";
import { FaCar } from "react-icons/fa";
import { FaMotorcycle } from "react-icons/fa6";
import { BugReport, Class, Public, Settings, Subtitles } from "@material-ui/icons";
import { MdSportsMotorsports } from "react-icons/md";
import { GiSteeringWheel } from "react-icons/gi";

export function AsideMenuList({ layoutProps }) {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Dashboard</span>
          </NavLink>
        </li>
        <li className="menu-section">
          <h4 className="menu-text">USERS</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/admins",
              false
            )} ${getMenuItemActive("/edit-admin", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/admins">
              <span className="menu-icon">
                <AssignmentIndIcon />
              </span>
              <span className="menu-text">Administrators</span>
            </NavLink>
          </li>
        )}
        <li
          className={`menu-item ${getMenuItemActive("/peticiones", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/peticiones">
            <span className="menu-icon">
              <Class />
            </span>
            <span className="menu-text">Peticiones</span>
          </NavLink>
        </li>
        {user.role === "admin" && (
          <li
            className={`menu-item ${getMenuItemActive("/logs", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/logs">
              <span className="menu-icon">
                <BugReport />
              </span>
              <span className="menu-text">Logs de errores</span>
            </NavLink>
          </li>
        )}

        <li className="menu-section">
          <h4 className="menu-text">MISCELLANY</h4>
          <i className="menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>
        {user.role === "admin" && (
          <>
            <li
              className={`menu-item ${getMenuItemActive(
                "/languages",
                false
              )} ${getMenuItemActive("/edit-language", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/languages">
                <span className="menu-icon">
                  <LanguageIcon />
                </span>
                <span className="menu-text">Languages</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/texts",
                false
              )} ${getMenuItemActive("/edit-text", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/texts">
                <span className="menu-icon">
                  <DescriptionIcon />
                </span>
                <span className="menu-text">Texts</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/paises",
                false
              )} ${getMenuItemActive("/edit-pais", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/paises">
                <span className="menu-icon">
                  <Public />
                </span>
                <span className="menu-text">Paises</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/provincias",
                false
              )} ${getMenuItemActive("/edit-provincia", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/provincias">
                <span className="menu-icon">
                  <Public />
                </span>
                <span className="menu-text">Provincias</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/localidades",
                false
              )} ${getMenuItemActive("/edit-localidad", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/localidades">
                <span className="menu-icon">
                  <Public />
                </span>
                <span className="menu-text">Localidades</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/modalidades",
                false
              )} ${getMenuItemActive("/edit-modalidad", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/modalidades">
                <span className="menu-icon">
                  <Subtitles />
                </span>
                <span className="menu-text">Modalidades</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/years",
                false
              )} ${getMenuItemActive("/edit-year", false)}`}
              aria-haspopup="true"
            >
              <NavLink className="menu-link" to="/years">
                <span className="menu-icon">
                  <Subtitles />
                </span>
                <span className="menu-text">Años</span>
              </NavLink>
            </li>
            <li
              className={`menu-item ${getMenuItemActive(
                "/configuracion/683419286f9d6a48327353c2",
                false
              )}`}
              aria-haspopup="true"
            >
              <NavLink
                className="menu-link"
                to="/configuracion/683419286f9d6a48327353c2"
              >
                <span className="menu-icon">
                  <Settings />
                </span>
                <span className="menu-text">Configuración</span>
              </NavLink>
            </li>
          </>
        )}
      </ul>

      {/* end::Menu Nav */}
    </>
  );
}
